module.exports = __webpack_public_path__ + "img/gaji_image.7c882d45.png";